import Wrapper from "../../layout/Wrapper";
import CommissionPayoutHistoryPage from "../../screens/comission/CommissionPayoutHistoryPage";

import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
	title: "CommissionPayoutHistoryPage",
	description: "",
};
	
export default function CommissionPayoutHistoryPageRoute() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<CommissionPayoutHistoryPage />
		</Wrapper>
	);
}